/*
 * © 2026 eggs unimedia GmbH
 * Coded with love 💛
 */

import React, { createContext, useContext } from 'react'
import { useQuery } from '@tanstack/react-query'
import { gondolaService } from '../services/gondolaService'

const GondolasContext = createContext()

export const GondolasProvider = ({ children }) => {
  const { data: gondolas = [], isLoading: loading, error } = useQuery({
    queryKey: ['gondolas'],
    queryFn: () => gondolaService.getGondolas(),
    staleTime: 5 * 60 * 1000,
    select: (data) => data,
  })

  return (
    <GondolasContext.Provider value={{ gondolas, loading, error }}>
      {children}
    </GondolasContext.Provider>
  )
}

export const useGondolas = () => {
  const context = useContext(GondolasContext)
  if (!context) {
    throw new Error('useGondolas must be used within GondolasProvider')
  }
  return context
}
